// @flow

/**
 * @NOTE
 * deviceSizeがサービスで共通化されるまでwww用の値で作成しています。
 * packages/shared/styles/media.js に修正を行なった場合、このファイルも同様の修正を行なってください。
 */

import { css } from 'styled-components'
import { deviceSizes } from './_variables'

// Iterate through the sizes and create a media template
export const mediaMax = Object.keys(deviceSizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${deviceSizes[label] - 1}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

export const mediaMin = Object.keys(deviceSizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${deviceSizes[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

export const mediaOn = Object.keys(deviceSizes).reduce((acc, label, i) => {
  const nextLabel = Object.keys(deviceSizes)[i + 1]

  acc[label] = (...args) => css`
    @media (min-width: ${deviceSizes[nextLabel] ||
        0}px) and (max-width: ${deviceSizes[label] - 1}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})



// WEBPACK FOOTER //
// ./src/components/styles/_media.js